export default "__VITE_ASSET__8cc63c6b__"